import type { ReactElement } from 'react';

export type BooksKindFilter = 'all' | 'sales' | 'royalty' | 'purchase' | 'jib';

export interface BooksTileCounts {
  all: number;
  sales: number;
  royalty: number;
  purchase: number;
  jib: number;
}

interface BooksTilesProps {
  counts: BooksTileCounts;
  filter: BooksKindFilter;
  onFilter: (filter: BooksKindFilter) => void;
}

function tileClass(active: boolean): string {
  return `tile ${active ? 'tile-active' : ''}`;
}

export function BooksTiles({ counts, filter, onFilter }: BooksTilesProps): ReactElement {
  return (
    <section className="tiles-grid" data-testid="books-tiles">
      <article className={tileClass(filter === 'all')} onClick={() => onFilter('all')}>
        <h3>All</h3>
        <p>{counts.all}</p>
      </article>
      <article className={tileClass(filter === 'sales')} onClick={() => onFilter('sales')}>
        <h3>Sales AR</h3>
        <p>{counts.sales}</p>
      </article>
      <article className={tileClass(filter === 'royalty')} onClick={() => onFilter('royalty')}>
        <h3>Royalty AP</h3>
        <p>{counts.royalty}</p>
      </article>
      <article className={tileClass(filter === 'purchase')} onClick={() => onFilter('purchase')}>
        <h3>Well cost AP</h3>
        <p>{counts.purchase}</p>
      </article>
      <article className={tileClass(filter === 'jib')} onClick={() => onFilter('jib')}>
        <h3>Simple JIB</h3>
        <p>{counts.jib}</p>
      </article>
    </section>
  );
}
